import { Alert } from 'antd';
import Marquee from 'react-fast-marquee';
import useFetchAnnouncement from "../../hooks/useFetchAnnouncement.js";

const TopAnnouncement = () => {
    const { announcement } = useFetchAnnouncement();

    const visibleAnnouncement = announcement?.find(announcement => announcement.is_visible);
    const description = visibleAnnouncement?.description || '';
    const backgroundColor = `#${visibleAnnouncement?.color || '10A98C'}`;
    const fontSize = visibleAnnouncement?.font_size ? `${visibleAnnouncement.font_size}px` : '16px';

    return (
        <Alert
            banner
            showIcon={false}
            style={{
                backgroundColor,
                color: 'white',
                paddingLeft: 0,
                paddingRight: 0,
            }}
            message={
                <Marquee pauseOnHover gradient={false} style={{ fontSize, color: 'white' }}>
                    <div style={{ marginRight: '1rem' }}>
                        {description}
                    </div>
                </Marquee>
            }
        />
    );
};

export default TopAnnouncement;